import { Link } from 'react-router-dom';
import { useRef } from 'react';

const products = [
  {
    image: 'https://public.readdy.ai/ai/img_res/9f02b6c7f263429d0369b97d9be66da5.jpg',
    name: 'Smart Lock System',
    price: '$189.99'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20quality%20white%20bedding%20set%20with%20pillows%20and%20duvet%2C%20premium%20cotton%20linens%20for%20vacation%20rental%2C%20crisp%20clean%20sheets%2C%20hospitality%20grade%20bedding%2C%20simple%20white%20background%2C%20product%20photography&width=400&height=400&seq=prod-002&orientation=squarish',
    name: 'Premium Bedding Set',
    price: '$129.99'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Welcome%20basket%20with%20amenities%20for%20Airbnb%20guests%2C%20wicker%20basket%20with%20toiletries%20snacks%20and%20local%20treats%2C%20hospitality%20gift%20set%2C%20simple%20clean%20background%2C%20product%20photography%20style&width=400&height=400&seq=prod-003&orientation=squarish',
    name: 'Guest Welcome Kit',
    price: '$49.99'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Smoke%20detector%20and%20carbon%20monoxide%20alarm%20for%20rental%20property%20safety%2C%20white%20ceiling%20mounted%20safety%20device%2C%20home%20security%20equipment%2C%20simple%20clean%20background%2C%20product%20photography&width=400&height=400&seq=prod-004&orientation=squarish',
    name: 'Safety Alarm Bundle',
    price: '$79.99'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Professional%20cleaning%20supplies%20kit%20for%20vacation%20rental%20turnover%2C%20organized%20caddy%20with%20eco-friendly%20cleaning%20products%2C%20hospitality%20housekeeping%20essentials%2C%20simple%20clean%20background%2C%20product%20photography&width=400&height=400&seq=prod-005&orientation=squarish',
    name: 'Cleaning Essentials Kit',
    price: '$89.99'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Decorative%20wall%20art%20set%20for%20modern%20Airbnb%20interior%2C%20framed%20abstract%20prints%20in%20neutral%20tones%2C%20contemporary%20home%20decor%2C%20simple%20clean%20background%2C%20product%20photography%20style&width=400&height=400&seq=prod-006&orientation=squarish',
    name: 'Decor Art Set',
    price: '$159.99'
  }
];

export default function ProductMarketplace() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#1A2332] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Everything You Need to Succeed
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Curated supplies and equipment specifically selected for successful Airbnb hosting. Quality products that guests love and hosts trust.
          </p>
        </div>

        <div className="relative">
          {/* Scroll Buttons */}
          <button 
            onClick={() => scroll('left')}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-2xl text-gray-700"></i>
          </button>
          
          <button 
            onClick={() => scroll('right')}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-2xl text-gray-700"></i>
          </button>

          {/* Products Scroll */}
          <div 
            ref={scrollRef}
            className="flex gap-6 overflow-x-auto scrollbar-hide pb-4"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {products.map((product, index) => (
              <div 
                key={index}
                className="flex-shrink-0 w-80 bg-white border border-gray-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300 group cursor-pointer"
              >
                <div className="relative h-80 bg-gray-50 overflow-hidden">
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                
                <div className="p-6">
                  <h3 className="text-xl font-bold text-[#1A2332] mb-2">
                    {product.name}
                  </h3>
                  
                  <div className="flex items-center justify-between">
                    <span className="text-2xl font-bold text-[#FF6B6B]">
                      {product.price}
                    </span>
                    
                    <button className="w-10 h-10 bg-[#FF6B6B] rounded-full flex items-center justify-center hover:bg-[#ff5252] transition-colors cursor-pointer">
                      <i className="ri-shopping-cart-line text-white text-lg"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <Link 
            to="/services"
            className="inline-block bg-[#FF6B6B] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#ff5252] transition-all hover:shadow-lg cursor-pointer whitespace-nowrap"
          >
            Browse Full Catalog
          </Link>
        </div>
      </div>
    </section>
  );
}
